module.exports = __webpack_public_path__ + "static/preview-kr-ed9491bf5129d1af738f82d5b7389601.jpg";